import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 15000,
});

/* ---------------- REQUEST INTERCEPTOR ---------------- */

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ---------------- RESPONSE INTERCEPTOR ---------------- */

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    console.log("Status", status, "message", error.response);
    if (status === 401) {
      // Token expired / invalid
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Optional: redirect to login
      window.location.href = "/";
    }

    if (status === 403) {
      console.warn("Access denied");
    }

    return Promise.reject(error);
  }
);

export default api;
